import { makeQueryResultSubscriptionHook } from 'common/utils/makeQueryResultSubscriptionHook';

import { useCurrentContactQuery } from './__generated__/currentContact';
import { useMyRegionQuery } from './__generated__/myRegion';

export const useCashedMyRegion = makeQueryResultSubscriptionHook(useMyRegionQuery);
export const useCachedCurrentContact = makeQueryResultSubscriptionHook(useCurrentContactQuery);
